// Design System
import { Avatar, Checkbox, IconButton } from "@toddle-edu/ds-web";
import { ChevronDownOutlined } from "@toddle-edu/ds-icons";

// External
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { memo, useCallback } from "react";

// CSS
import classes from "./ListItem.scss";

const ListItem = ({
  id,
  name,
  src,
  showAvatar = true,
  shape = "circle",
  isAccordion,
  isExpanded,
  onClick,
  onCheckboxClick,
  isChecked,
  isIndeterminate,
  testId,
}) => {
  const handleCheckboxClick = useCallback(
    e => {
      if (e.target.checked === undefined) return;

      onCheckboxClick({ id, checked: e.target.checked });
    },
    [id, onCheckboxClick]
  );

  return (
    <div className={classes.listItem}>
      {showAvatar ? (
        <div>
          <Avatar id={id} name={name} src={src} shape={shape} />
        </div>
      ) : null}

      <div className={classNames(classes.text, "text-body")}>{name}</div>

      {isAccordion ? (
        <IconButton
          icon={<ChevronDownOutlined variant="subtle" />}
          type="plain"
          variant="neutral"
          isCompact
          testId={`${testId}-${id}`}
          className={classNames(classes.expandButton, {
            [classes.expanded]: isExpanded,
          })}
          onClick={onClick}
        />
      ) : null}

      <Checkbox
        testId={`${testId}-${id}`}
        onChange={handleCheckboxClick}
        isChecked={isChecked}
        isIndeterminate={isIndeterminate}
      />
    </div>
  );
};

ListItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  src: PropTypes.string,
  showAvatar: PropTypes.bool,
  shape: PropTypes.string,
  isAccordion: PropTypes.bool,
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func,
  onCheckboxClick: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  isIndeterminate: PropTypes.bool,
  testId: PropTypes.string,
};

ListItem.defaultProps = {
  src: null,
  showAvatar: true,
  shape: "circle",
  isAccordion: false,
  isExpanded: false,
  onClick: null,
  isChecked: false,
  isIndeterminate: false,
  testId: "",
};

export default memo(ListItem);
